import { render, staticRenderFns } from "./PwLogin.vue?vue&type=template&id=3a45d7bc&scoped=true&"
import script from "./PwLogin.vue?vue&type=script&lang=js&"
export * from "./PwLogin.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.css?vue&type=style&index=0&id=3a45d7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a45d7bc",
  null
  
)

export default component.exports